import React, { useState } from 'react';
import { useEffect } from 'react';
import DashboardList from '../DashboardList/DashboardList';
import Sidebar from '../Sidebar/Sidebar';

const Patients = () => {
    const [allPatients, setAllPatients] = useState([]);

    useEffect(()=> {
        fetch('http://localhost:5000/Appointments')
        .then(res => res.json())
        .then( data => {
            setAllPatients(data);
        })
    },[])
    return (
        <section style={{background: '#f4fdfb'}}>
            <div className="ps-0 container-fluid row">
                <div className="col-md-2">
                    <Sidebar></Sidebar>
                </div>
                <div className="col-md-10">
                    <h5 className='mt-5'>Patients</h5>
                    <DashboardList title='All Patients ' patients={true} appointments={allPatients}></DashboardList>
                </div>
            </div>
        </section>
    );
};

export default Patients;